module.exports = __webpack_public_path__ + "img/ideation-09-milestone-phase-1.5b84fdc4.jpg";